import { useState } from 'react';
import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_KEY } from '@/components/utils/constants';
import { invokeEdgeFunction } from '@/utils/supabase-functions';

export interface SharedProposalData {
  success: boolean;
  itinerary?: any;
  sharedBy?: {
    first_name: string;
    last_name: string;
    logo_url?: string;
    logo_small_url?: string;
    agency_name?: string;
  };
  payment_enabled?: boolean;
  error?: 'link_not_found' | 'link_expired' | 'invalid_password' | 'unknown_error';
}

export const useSharedProposal = (shareToken: string) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<SharedProposalData | null>(null);

  const fetchProposal = async (password?: string) => {
    setIsLoading(true);
    setError(null);
    
    try {
      // Create a fresh Supabase client without auth
      const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

      const payload: any = { shareToken };
      if (password) {
        payload.password = password;
      }

      console.log("[useSharedProposal] Calling get-shared-itinerary:", payload);

      const data = await invokeEdgeFunction<SharedProposalData>(supabase, "get-shared-itinerary", {
        body: JSON.stringify(payload),
      });

      if (!data || !data.success) {
        setError(data?.error || "unknown_error");
        return;
      }

      console.log("[useSharedProposal] Success response:", {
        hasItinerary: !!data.itinerary,
        hasSharedBy: !!data.sharedBy,
        paymentEnabled: data.payment_enabled,
        totalPrice: data.itinerary?.total,
      });

      setData(data);
    } catch (e: unknown) {
      console.error('Network error:', e);
      setError((e as Error)?.message || 'network_error');
    } finally {
      setIsLoading(false);
    }
  };

  return { fetchProposal, isLoading, error, data };
};
